import '../adventure.css';
import { useTranslation } from 'react-i18next';
import Option from './Option';
import Fever from '../../../assets/designSystem/icons/firstAid/Symptoms/Fever.png';
import Cough from '../../../assets/designSystem/icons/firstAid/Symptoms/Cough.png';
import Rash from '../../../assets/designSystem/icons/firstAid/Symptoms/Rash.svg';
import Diarrhoea from '../../../assets/designSystem/icons/firstAid/Symptoms/Diarrhoea.png';
import Vomiting from '../../../assets/designSystem/icons/firstAid/Symptoms/Vomiting.png';
import Earpain from '../../../assets/designSystem/icons/firstAid/Symptoms/Earpain.png';

export default function Symptoms() {
  const { t } = useTranslation();
  const options = [
    {
      label: t('staticPages.homePageChild.cards.signs.fever'),
      image: Fever,
      color: '#ff2a26',
      className: 'left__top',
      to: 'fever',
    },
    {
      label: t('staticPages.homePageChild.cards.signs.cough'),
      image: Cough,
      color: '#ff8a00',
      className: 'top__right',
      to: 'cough',
    },
    {
      label: t('staticPages.homePageChild.cards.signs.rash'),
      image: Rash,
      color: '#ffc631',
      className: 'left__middle',
      to: 'rash',
    },
    {
      label: t('staticPages.homePageChild.cards.signs.diarrhoea'),
      image: Diarrhoea,
      color: '#14c7c4',
      className: 'right__lower',
      to: 'diarrhoea',
    },
    {
      label: t('staticPages.homePageChild.cards.signs.vomiting'),
      image: Vomiting,
      color: '#51a0cd',
      className: 'left__bottom',
      to: 'vomiting',
    },
    {
      label: t('staticPages.homePageChild.cards.signs.earPain'),
      image: Earpain,
      color: '#ffc631',
      className: 'right__last',
      to: 'ear-pain',
    },
  ];
  return (
    <div className="map__container">
      <svg
        className="connector__svg"
        xmlns="http://www.w3.org/2000/svg"
        width="105"
        height="290"
        viewBox="0 0 105 290"
        fill="none"
      >
        <path
          d="M7.18659 2.00024C30.8016 16.7842 57.3686 36.0034 86.887 59.6578C116.406 83.3124 92.791 108.445 16.0422 135.056C39.6572 155.754 65.9306 155.432 95.4495 185C89.9734 205.297 16.0422 251 2.18659 244C-3.28946 264.297 114.805 293 100.949 286"
          stroke="#D4A574"
          strokeWidth="4"
          strokeLinecap="round"
          strokeDasharray="15 10"
        />
      </svg>
      {options.map((option) => (
        <Option
          key={option.label}
          image={option.image}
          label={option.label}
          color={option.color}
          className={option.className}
          to={option.to}
        />
      ))}
    </div>
  );
}
